import {
  CONCURSO_INIT,
  CONCURSO_SELECTED,
  CONCURSOSCREEN_SELECTED,
  DEZENA_SELECTED,
  CONCURSO_DATE_SELECTED,
} from "./concursoActions";

const CONCURSO_INITIAL_STATE = {
  concursoScreen: 0,
  concursoType: null,
  dezenasSel: [],
  qtdDezenasSel: 0,
  buttons: [],
  datasConcursoSel: [],
};

export default (state = CONCURSO_INITIAL_STATE, action) => {
  switch (action.type) {
    case CONCURSO_INIT:
      return CONCURSO_INITIAL_STATE;
    case CONCURSO_SELECTED:
      var currentScreen = 1;
      if (
        action.payload.objTipoJogo.sntTipoJogo === 0 &&
        action.payload.objTipoJogo.vchSigla === "A"
      ) {
        currentScreen = 2;
      }
      if (
        action.payload.objTipoJogo.sntTipoJogo === 0 &&
        action.payload.objTipoJogo.vchSigla === "R"
      ) {
        currentScreen = 4;
      }
      if (
        action.payload.objTipoJogo.sntTipoJogo === 0 &&
        action.payload.objTipoJogo.vchSigla === "E"
      ) {
        currentScreen = 5;
      }
      if (action.payload.objTipoJogo.sntTipoJogo === 3) {
        currentScreen = 3;
      }
      if (action.payload.objTipoJogo.sntTipoJogo === 999999) {
        currentScreen = 6;
      }
      return {
        ...state,
        concursoScreen: currentScreen,
        concursoType: action.payload,
      };
    case CONCURSOSCREEN_SELECTED:
      return {
        ...state,
        concursoScreen: action.payload,
      };
    case DEZENA_SELECTED:
      return {
        ...state,
        dezenasSel: action.payload,
        qtdDezenasSel: action.payload.length,
      };
    case CONCURSO_DATE_SELECTED:
      return {
        ...state,
        datasConcursoSel: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/concurso/concursoReducer.js